import styles from "../styles/planesEsport.module.css";
import { Link } from "react-router-dom";

function PlanesEsport() {
    const plans = [
        { tipo: "Esport",name: "BASIC", price: "9.80€", texto1: 'Fisioterapia', texto2: 'Entrenamientos', texto3: 'Medicina', texto4: 'Omeopatia', texto5: 'Masaje', texto6: 'Alimentación' },
        { tipo: "Esport", name: "STANDARD", price: "19.80€", texto1: 'Fisioterapia', texto2: 'Entrenamientos', texto3: 'Medicina', texto4: 'Nutrición', texto5: 'Masaje', texto6: 'Ayunos extremos' },
        { tipo: "Esport", name: "PREMIUM", price: "29.80€", texto1: 'FisioterapiaXL', texto2: 'Entrenamientos PRO', texto3: 'Medicina Extra', texto4: 'Omeopatia', texto5: 'Masaje', texto6: 'Nutrición' },
    ];

    return (
        <section className={styles.pricing}>
            <h2>Planes Esport</h2>
            <div className={styles.plans}>
                {plans.map((plan, index) => (
                    <div key={index} className={styles.plan}>
                        <h3>{plan.name}</h3>
                        <p>{plan.price}</p>
                        <p>{plan.texto1}</p>
                        <p>{plan.texto2}</p>
                        <p>{plan.texto3}</p>
                        <p>{plan.texto4}</p>
                        <p>{plan.texto5}</p>
                        <p>{plan.texto6}</p>
                        <button>
                            <Link 
                                className={styles.linkButton}
                                to='/contacto' // La ruta es directa
                                state={{ planSeleccionado: plan }} // El state es una prop aparte
                            >
                                Elegir
                            </Link>
                        </button>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default PlanesEsport;